import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Chatbot from "./pages/Chatbot";

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Chatbot} />
      </Switch>
    </BrowserRouter>
  );
}
